export enum AwsAmplifyHubEvents {
    cognitoHostedUI = 'cognitoHostedUI',
    signIn = 'signedIn',
    signOut = 'signOut',
}

export enum AwsAmplifyErrorNames {
    UserAlreadyAuthenticatedException = 'UserAlreadyAuthenticatedException',
}
